var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" row text-primary"},[_c('div',{staticClass:"col-12 text-center"},[_c('loading-round',{attrs:{"dot-background":"rgb( 57,84,164 )"}}),_c('div',{staticClass:"mt-3"},[_vm._v("Please wait . . .")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }